/** @format */

import FilterListIcon from '@mui/icons-material/FilterList';

import {
  TooltipContentContainer,
  TooltipTitle,
  ButtonGroupWrapper,
  ButtonGroupBox,
  ButtonsContainer,
  TooltipButton,
  DescriptionText,
  IconWrapper,
} from './styles';

export const MediaplanTooltipContent = () => {
  return (
    <TooltipContentContainer>
      <TooltipTitle>Настройте медиаплан, чтобы следить за самыми важными кампаниями</TooltipTitle>

      <ButtonGroupWrapper>
        <ButtonGroupBox>
          <ButtonsContainer>
            <IconWrapper>
              <FilterListIcon />
            </IconWrapper>
            <TooltipButton>Больше тратят</TooltipButton>
            <TooltipButton disabled>Больше приносят</TooltipButton>
          </ButtonsContainer>
          <DescriptionText>
            Моментальная оценка KPI и ошибок по кампаниям с самым большим расходом
          </DescriptionText>
        </ButtonGroupBox>

        <ButtonGroupBox>
          <ButtonsContainer>
            <IconWrapper>
              <FilterListIcon />
            </IconWrapper>
            <TooltipButton disabled>Больше тратят</TooltipButton>
            <TooltipButton>Больше приносят</TooltipButton>
          </ButtonsContainer>
          <DescriptionText>Или по кампаниям-драйверам со множеством конверсий</DescriptionText>
        </ButtonGroupBox>
      </ButtonGroupWrapper>
    </TooltipContentContainer>
  );
};
